const DOMAIN_REGEX = /^(?!-)(?!.*--)[a-z0-9-]+(\.[a-z0-9-]+)+$/i;

export function normalizeDomain(value: string | null | undefined): string | null {
  if (!value) return null;
  const lower = value.trim().toLowerCase();
  if (!lower) return null;
  const cleaned = lower.replace(/\.+$/, '');
  if (!cleaned) return null;
  if (!DOMAIN_REGEX.test(cleaned)) return null;
  return cleaned;
}

export function extractEmailDomain(input: string | null | undefined): string | null {
  if (!input) return null;
  const trimmed = input.trim();
  if (!trimmed) return null;
  const atIndex = trimmed.lastIndexOf('@');
  const domainPart = atIndex >= 0 ? trimmed.slice(atIndex + 1) : trimmed;
  return normalizeDomain(domainPart);
}
